export const footerVariants = [
  'flex',
  'flex-col-reverse',
  'p-4',
  'border-t',
  'border-color-ref-ui-divider-strong',
];
